// extracted by mini-css-extract-plugin
export default {"more-text":"more-text_more-text__3DNen","more-text--text":"more-text_more-text--text__1BrLg","_plain":"more-text__plain__3LMOi"};